export default __webpack_public_path__ + "static/media/laundryMachine.1d89a53a.jpg";